import { useQuery } from "@tanstack/react-query";
import { getAds, type Ad } from "~/lib/server-functions/get-ads";
import { QUERY_KEYS } from "./queryKeys";

export const useAds = () => {
  return useQuery<Ad[]>({
    queryKey: [QUERY_KEYS.ADS],
    queryFn: async () => {
      const ads = await getAds();
      return ads;
    },
  });
};

